import { VueConstructor} from "vue";
import websocketMessage from "@/utils/websocketMessage";


const wm = {
  install:(vue:VueConstructor) => {
    vue.prototype.wsMsgModule = websocketMessage
  }
}
export default wm;
